import { finalize } from 'rxjs/operators';
import { ticketFormErrors, ticketHasMessage, ticketRequestError } from '../ticket-form.utils';
import { Component, OnInit, TemplateRef } from '@angular/core';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { BsModalService } from 'ngx-bootstrap/modal';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { TicketService } from 'src/app/Service/Ticket/Ticket.service';
import { TicketCategoryService } from 'src/app/Service/TicketCategory/TicketCategory.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-TicketForm',
  templateUrl: './TicketForm.component.html',
  styleUrls: ['./TicketForm.component.scss', '../ticket-shared.css']
})
export class TicketFormComponent implements OnInit {
  ErrorMessage = '';
  ValidationErrors: { [key: string]: string } = {};

  Title:string=""
  TicketCategory:string="0"
  public Editor = ClassicEditor;
  public model = {
    editorData: ''
};
  public config = {
    language: 'fa'
};

  constructor(
    private Alertify_Service:AlertifyService,
    private Ticket_Service:TicketService,
    private modalService: BsModalService,
    private TicketCategory_Service:TicketCategoryService,
    private Nav_Service:NavService,
  ) { }

  ngOnInit() {


    this.Nav_Service.CheckValidPage(1102).subscribe(
      data=>{
        this.Read_TicketCategory()
      }
      ,error=>{
        this.ErrorMessage = ticketRequestError(error);
        this.Alertify_Service.ErrorMessage(this.ErrorMessage);
      }
    )
  }

  //#region Ticket Category

  TicketCategory_DataList:Array<General_Interface>
  Read_TicketCategory(){
    this.InProccessing=true
    this.TicketCategory_Service.GetActiveList().pipe(finalize(() => this.InProccessing = false)).subscribe(
      data=>{
        this.InProccessing=false
        this.TicketCategory_DataList=data
      },error=>{
        this.ErrorMessage = ticketRequestError(error);
        this.Alertify_Service.ErrorMessage(this.ErrorMessage);
      }
    )
  }

  //#endregion

  //#region Image
BaseUrl=environment.BaseUrl
UploadImageSrc_List:Array<string>=[]
UploadImageSrc:string=''
InProccessing_Image1:boolean=false
uploadImage1(files) {
  if (this.InProccessing_Image1 || !files || files.length === 0)
    return;

  const formData = new FormData();

  for (const file of files) {
    formData.append(file.name, file);
  }

  this.InProccessing_Image1=true

  this.Ticket_Service.uploadFile(formData).pipe(finalize(() => this.InProccessing_Image1 = false)).subscribe(
    data=>{
      this.InProccessing_Image1=false
      if(data['id']==0)
      {
        this.Alertify_Service.ErrorMessage(data['filename'])
      }
      else{
        this.Alertify_Service.SuccessMessage("فایل آپلود شد")
        this.UploadImageSrc=data['filename']
      }
    }, error => { this.ErrorMessage = ticketRequestError(error); this.Alertify_Service.ErrorMessage(this.ErrorMessage); }
  )

}

Remove_uploadImage1(){
  this.UploadImageSrc=''
}

Add_uploadImage1(){
  this.UploadImageSrc_List.push(this.UploadImageSrc)
  this.UploadImageSrc=''
  this.Alertify_Service.SuccessMessage("به جدول اضافه شد")
}

UploadImageSrc_List_Delete(id:number)
    {
      this.UploadImageSrc_List.splice(id,1)
      this.Alertify_Service.SuccessMessage("حذف شد")
    }

    modalRef_Image: any;
    ModalimageUrl:string=''
    openModal(template: TemplateRef<any>,imageUrl:string) {
      this.ModalimageUrl=imageUrl
      this.modalRef_Image = this.modalService.show(template);
    }

//#endregion


  InProccessing:boolean=false
  onSubmitForm(){
    if (this.InProccessing || this.InProccessing_Image1) return;
    this.ErrorMessage = '';
    this.ValidationErrors = ticketFormErrors(this.Title, this.TicketCategory, this.model.editorData);
    if (Object.keys(this.ValidationErrors).length) return;
    this.InProccessing = true;
    this.Ticket_Service.SubmitTicket(this.model.editorData, 0,
      this.Title.trim(), Number(this.TicketCategory), this.UploadImageSrc_List)
      .pipe(finalize(() => this.InProccessing = false)).subscribe({
        next: () => {
          this.model.editorData = '';
          this.Title = '';
          this.TicketCategory = '0';
          this.UploadImageSrc_List = [];
          this.Alertify_Service.SuccessMessage('تیکت در سامانه ثبت شد');
        },
        error: error => { this.ErrorMessage = ticketRequestError(error); this.Alertify_Service.ErrorMessage(this.ErrorMessage); }
      });
  }
}
